export default __webpack_public_path__ + "static/media/bg0.19e99d3b.png";